import * as React from 'react'
import Popover, { PopoverOrigin } from '@mui/material/Popover'
import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import { useEffect } from 'react'
import { useGetActivityOnMount } from '../EditActivityPopover/hooks'
import { NormalizedActivity } from './EditActivityStatusForm/typings'
import { EditStatusActivityForm } from './EditActivityStatusForm/EditStatusActivityForm'

type Props = {
  activityId: number | undefined
  anchorEl: HTMLElement | null
  anchorOrigin?: PopoverOrigin
  onClose: () => void
  onSave?: (activity: NormalizedActivity) => void
}

export function EditActivityStatusPopover(props: Props) {
  const { activityId, onClose, onSave } = props
  const { anchorOrigin = { vertical: 'top', horizontal: 'left' } } = props
  const { activity, status } = useGetActivityOnMount(activityId)

  const open = !!activityId

  useEffect(() => {
    if (status === 'error') {
      onClose()
    }
  }, [onClose, status])

  return (
    <Backdrop open={open}>
      {activity && (
        <Popover
          id="popover"
          open={open}
          anchorEl={undefined}
          anchorReference={'none'}
          hideBackdrop={false}
          onClose={onClose}
          anchorOrigin={anchorOrigin}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {activityId !== null &&
            (status === 'loading' ? (
              <CircularProgress />
            ) : (
              <EditStatusActivityForm
                activity={activity}
                onClose={onClose}
                onSave={onSave}
              />
            ))}
        </Popover>
      )}
    </Backdrop>
  )
}
